@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: content;
}

.inner {
    grid-column: content;
    display: flex;
    align-items: center;
    padding: var(--spacer-24);
    gap: var(--spacer-24);
    transition: box-shadow 0.3s ease;

    @media (hover: hover) {
        &:hover {
            box-shadow: var(--box-shadow-2);
        }
    }
}

.mainContent {
    display: flex;
    gap: var(--spacer-40);
    flex: 1;

    @media ($below-tablet) {
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacer-12);
    }
}

.image {
    flex-shrink: 0;
    max-width: 72px;
    aspect-ratio: 3 / 4;
    overflow: hidden;

    @media ($below-tablet) {
        margin-bottom: auto;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.content {
    display: flex;
    align-items: center;
    gap: var(--spacer-16);
    flex: 1;

    @media ($below-tablet) {
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacer-8);
    }
}

.hasImage {
    @media ($below-tablet) {
        min-height: 96px;
    }
}

.headline {
    composes: fontHB32 from "../../styles/typography.module.scss";
    color: var(--color-text);
    max-width: 50%;

    @media ($below-tablet) {
        max-width: 100%;
    }
}

.body {
    composes: fontP16 from "../../styles/typography.module.scss";
    color: var(--color-text);
    flex: 1;
}

.link {
    composes: fontB16 from "../../styles/typography.module.scss";
    margin-left: auto;
    flex-shrink: 0;
    color: var(--color-text);

    @media ($below-tablet) {
        margin-left: 0;
    }
}
